import React, { useState } from 'react';
import Ripple from '../ui/Ripple';

const RipplePage = ({ onTransition }) => {
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleCircleClick = () => {
    setIsTransitioning(true);
    // Trigger transition after animation starts
    setTimeout(() => {
      if (onTransition) {
        onTransition();
      }
    }, 800); // Wait for enlargement animation
  };

  return (
    <div className="relative flex h-screen w-full flex-col items-center justify-center overflow-hidden">
      <Ripple 
        mainCircleSize={380}
        mainCircleOpacity={0.25}
        numCircles={8}
        onFirstCircleClick={handleCircleClick}
        isTransitioning={isTransitioning}
      />
    </div>
  );
};

export default RipplePage;